import {
  IconCpu,
  IconFileDollar,
  IconFileSettings,
  IconForms,
  IconHomePlus,
  IconInbox,
  IconInfoCircle,
  IconMap2,
  IconPackage,
  IconPlaneDeparture,
  IconUsersGroup,
  IconZoomMoney,
} from '@tabler/icons-react';
import {
  ALL_APP_IDS,
  ALL_FEATURE_IDS,
  ALL_VIEW_IDS,
} from 'constants/appConstants';
import ExtendedTabs from 'ui-component/extended/ExtendedTabs';
import OrgInfo from 'views/org/OrgInfo';
import PartPreferences from 'views/org/Preferences/PartPreferences';
import SubOrgs from 'views/org/SubOrgs';
import CustomPropertiesTable from 'views/properties/CustomProperties/CustomPropertiesTable';
import TeamPreferences from 'views/properties/Teams/TeamPreferences';
import InventoryPreferences from 'views/org/Preferences/InventoryPreferences';
import ProcurementPreferences from 'views/procurement/Preferences';
import DocAiExtractors from 'views/docai/Extractors';
import DocAiPreferences from 'views/docai/Preferences';
import ShippingPreferences from 'views/inventory/ShippingPreferences';
import MainCard from 'ui-component/cards/MainCard';
import useCustomTeamTypeName from 'hooks/useCustomTeamTypeName';
import InventoryAddresses from 'views/kitting/Addresses';
import PurchaseRulesTable from 'views/suppliers/PurchaseRulesTable';

export enum ORG_PREFERENCES_TABS {
  INFO = 'info',
  PARTS = 'parts',
  TEAMS = 'teams',
  INBOUND_EMAIL = 'inboundEmail',
  ADDRESSES = 'addresses',
  SHIPPING = 'shipping',
  INVENTORY = 'inventory',
  PURCHASING = 'purchasing',
  SUB_ORGS = 'subOrgs',
  DOCAI_EXTRACTORS = 'docaiExtractors',
  CUSTOM_PROPERTIES = 'customProperties',
  PURCHASE_RULES = 'purchaseRules',
}

const OrgPreferences = () => {
  const { defaultTeamTypeNamePlural } = useCustomTeamTypeName();

  return (
    <ExtendedTabs
      tabOptions={[
        {
          name: ORG_PREFERENCES_TABS.INFO,
          label: 'Info',
          icon: <IconInfoCircle />,
          contents: <OrgInfo />,
        },
        {
          name: ORG_PREFERENCES_TABS.PARTS,
          label: 'Parts',
          icon: <IconCpu />,
          contents: <PartPreferences />,
        },
        {
          name: ORG_PREFERENCES_TABS.TEAMS,
          label: defaultTeamTypeNamePlural,
          icon: <IconUsersGroup />,
          contents: <TeamPreferences />,
          permissionScope: {
            app: ALL_APP_IDS.PROPERTIES,
            view: ALL_VIEW_IDS.TEAMS_TABLE,
          },
        },
        {
          name: ORG_PREFERENCES_TABS.INBOUND_EMAIL,
          label: 'Inbound Email',
          icon: <IconInbox />,
          contents: <DocAiPreferences />,
          permissionScope: {
            app: ALL_APP_IDS.DOCAI,
            view: ALL_VIEW_IDS.DOC_AI_INBOX,
          },
        },
        {
          name: ORG_PREFERENCES_TABS.ADDRESSES,
          label: 'Addresses',
          icon: <IconMap2 />,
          contents: <InventoryAddresses />,
        },
        {
          name: ORG_PREFERENCES_TABS.SHIPPING,
          label: 'Shipping',
          icon: <IconPlaneDeparture />,
          contents: <ShippingPreferences />,
        },
        {
          name: ORG_PREFERENCES_TABS.INVENTORY,
          label: 'Inventory',
          icon: <IconPackage />,
          contents: <InventoryPreferences />,
        },
        {
          name: ORG_PREFERENCES_TABS.PURCHASING,
          label: 'Purchasing',
          icon: <IconFileDollar />,
          contents: <ProcurementPreferences />,
        },
        {
          name: ORG_PREFERENCES_TABS.PURCHASE_RULES,
          label: 'Purchase Rules',
          icon: <IconZoomMoney />,
          contents: (
            <MainCard>
              <PurchaseRulesTable />
            </MainCard>
          ),
        },
        {
          name: ORG_PREFERENCES_TABS.SUB_ORGS,
          label: 'Sub Orgs',
          icon: <IconHomePlus />,
          contents: <SubOrgs />,
          permissionScope: {
            app: ALL_APP_IDS.ORG_SETTINGS,
            feature: ALL_FEATURE_IDS.SUB_ORGS,
          },
        },
        {
          name: ORG_PREFERENCES_TABS.DOCAI_EXTRACTORS,
          label: 'DocAI Extractors',
          icon: <IconFileSettings />,
          contents: (
            <MainCard>
              <DocAiExtractors />
            </MainCard>
          ),
          permissionScope: {
            app: ALL_APP_IDS.DOCAI,
          },
        },
        {
          name: ORG_PREFERENCES_TABS.CUSTOM_PROPERTIES,
          label: 'Custom Properties',
          icon: <IconForms />,
          contents: (
            <MainCard>
              <CustomPropertiesTable />
            </MainCard>
          ),
        },
      ]}
      orientation="vertical"
      displayChildren
      queryParam="tab"
    />
  );
};

export default OrgPreferences;
